<template>
  <v-card class="pa-4">
    <v-layout v-if="queueText" mt-3><span v-html="queueText"></span></v-layout>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['queueText'])
  }
}
</script>

<style scoped>
.title-information {
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.25px;
  text-align: left;
  font-weight: bold;
}
</style>